export const URL_FAVORIES_CREATE = '/favorites/favorite/:project_id';
export const URL_FAVORIES_UPDATE = '/favorites/unfavorite/:project_id';
export const URL_FAVORIES_LIST = '/favorites/:project_id';
